import type { UserModel } from '@/domain/models/user.js';

export type ClientPermissions = {
    canCreateClient: boolean;
    canEditClientData: boolean;
    canManageDocuments: boolean;
    canEditSapConnection: boolean;
};

export function resolveClientPermissions(me: UserModel | null | undefined): ClientPermissions {
    const isAdm = Boolean(me?.isGlobalAdmin);
    const isPmo = me?.profile === 'PMO';
    return {
        canCreateClient: isAdm,
        canEditClientData: isAdm,
        canManageDocuments: isAdm || isPmo,
        canEditSapConnection: isAdm || isPmo
    };
}
